// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ThumbDownIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ThumbDown/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 9.5a1.5 1.5 0 0 1-3 0v-6a1.5 1.5 0 1 1 3 0v6ZM14 9.667v-5.43a2 2 0 0 0-1.105-1.79l-.05-.025A4 4 0 0 0 11.055 2H5.64a2 2 0 0 0-1.961 1.608l-1.2 6A2 2 0 0 0 4.439 12H8v4a2 2 0 0 0 2 2 1 1 0 0 0 1-1v-.667a4 4 0 0 1 .8-2.4l1.4-1.866a4 4 0 0 0 .8-2.4Z"
}));
export default ThumbDownIcon;